import { MenuItem, Select } from '@material-ui/core';
import React from 'react';

interface IProps {
  supplierType: string;
  handleSupplierTypes: (event: React.ChangeEvent<{ value: unknown }>) => void;
}

export const SupplierType = ({ handleSupplierTypes, supplierType }: IProps) => {
  return (
    <Select value={supplierType} onChange={handleSupplierTypes} label="Tipo de Fornecedor">
      <MenuItem value="F">Todos</MenuItem>
      <MenuItem value="M">Móveis</MenuItem>
      <MenuItem value="A">Acessórios</MenuItem>
    </Select>
  );
};
